import { Dispatch, MiddlewareAPI, AnyAction } from 'redux';
import { originalQueryKeyFactory } from '../../search/state/originalQueryKeyFactory';

export const exposeOriginalQueryKey = (store: MiddlewareAPI) => (
  next: Dispatch,
) => (action: AnyAction) => {
  const { originalQueryKey } = store.getState().queryParams;
  originalQueryKeyFactory.set(originalQueryKey);
  return next(action);
};
